import { Navigate, RouteObject } from 'react-router-dom';
import { ContactUsPage } from '@common/contact/contact-us-page';
import { CustomPageLayout } from '@common/custom-page/custom-page-layout';
import { NotFoundPage } from '@common/ui/not-found-page/not-found-page';
import React from 'react';
import PricePlans from '@app/PricePlans';
import Chat from '@app/Chat';
import { Provider } from 'react-redux';
import { store } from '@app/lib/store';
import CompanyUsers from '@app/CompanyUsers';
import UpdateUser from '@app/UpdateUser';
import { authGuard } from '@common/auth/guards/auth-route';
import { lazyAdminRoute } from '@common/admin/routes/lazy-admin-route';

export const commonRoutes: RouteObject[] = [
  {
    path: 'contact',
    element: <ContactUsPage />,
  },
  {
    path: 'pages/:pageSlug',
    element: <CustomPageLayout />,
  },
  {
    path: 'pages/:pageId/:pageSlug',
    element: <CustomPageLayout />,
  },
  {
    path: '404',
    element: <NotFoundPage />,
  },
  {
    path: 'plans',
    element: <PricePlans />,
  },
  {
    path: 'chat',
    element: <Provider store={store}><Chat></Chat></Provider>,
  },
  // {
  //   path: 'company-users',
  //   loader: () => authGuard({permission: 'users.update'}),
  //   lazy: () => lazyAdminRoute('UpdateUserPage'),
  //   children: [
  //     {
  //       index: true,
  //       element: <CompanyUsers/>,
  //     },
  //     {
  //       path: ':id/details',
  //       element: <UpdateUser/>,
  //     }
  //   ]
  // }
  {
    path: 'company-users',
    element: <CompanyUsers/>,
  },
  // {
  //   path: 'company-users/:userId',
  //   loader: () => authGuard({ permission: 'users.update' }),
  //   lazy: () => lazyAdminRoute('UpdateUserPage'),
  //   children: [
  //     {
  //       index: true,
  //       element: <Navigate to="details" replace />,
  //     },
  //     {
  //       path: 'details',
  //       lazy: () => lazyAdminRoute('UpdateUserDetailsTab'),
  //     },
  //     {
  //       path: 'permissions',
  //       lazy: () => lazyAdminRoute('UpdateUserPermissionsTab'),
  //     },
  //     {
  //       path: 'security',
  //       lazy: () => lazyAdminRoute('UpdateUserSecurityTab'),
  //     },
  //     {
  //       path: 'date',
  //       lazy: () => lazyAdminRoute('UpdateUserDatetimeTab'),
  //     },
  //     {
  //       path: 'api',
  //       lazy: () => lazyAdminRoute('UpdateUserApiTab'),
  //     },
  //   ],
  // },
];
